module.exports = __webpack_public_path__ + "static/img/CMwithBot&NES-Website.e78f4d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CMwithBot&NES-Website.png
// module id = U5NX
// module chunks = 1